
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BoPanel } from 'bonomo';
import { IUser, IUserMgm } from '@/model/User/UserInterface';
import { IShortUser } from '@/model/shortInterfaces';
import { IAuthUserData } from '@/store/modules/authModule';
import UserNav from '@/components/user/widget/UserNav.vue';
import UserSearch from '@/components/user/widget/UserSearch.vue';
import Datim from '@/components/shared/Datim.vue';

const userModule = namespace('userModule');
const authModule = namespace('authModule');

@Component({
  name: 'UserMgm',
  components: {
    BoPanel,
    UserNav,
    UserSearch,
    Datim,
  },
})
export default class UserMgm extends Vue {
  @Prop()
  protected userId!: number;

  @userModule.Getter('user')
  protected user!: IUser;

  @userModule.Getter('mgm')
  protected mgm!: IUserMgm;

  @userModule.Action('fetchUser')
  private fetchUser!: (userId: number) => Promise<any>;

  @userModule.Action('fetchMgm')
  private fetchMgm!: (userId: number) => Promise<any>;

  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  protected loading: boolean = true;

  get isSelf(): boolean {
    return '' + this.$route.params.userId === '' + this.authUser.id;
  }

  get headers() {
    return [
      { text: this.$t('users.mgm.fields.name'), value: 'name', sortable: false },
      { text: this.$t('users.mgm.fields.email'), value: 'email', sortable: true },
      { text: this.$t('users.mgm.fields.phone'), value: 'phone_number', sortable: false },
      { text: this.$t('users.mgm.fields.registered'), value: 'created_at', sortable: true },
    ];
  }

  loadData() {
    this.fetchUser(this.userId);
    this.fetchMgm(this.userId);
  }

  private onGotoUser(user: IShortUser) {
    if (user.id !== this.userId) {
      this.$router.push({ name: 'userMgm', params: { userId: '' + user.id } });
      this.loadData();
    }
  }

  private goToUser(userId: number) {
    this.$router.push({ name: 'user', params: { userId: '' + userId } });
  }
}
